import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import Popup from '../../Popup';
import Logo from '@wix/da-ds/pkg/Logo';
import UserLink from '../../User/Link';
import withPopupArt from '../withPopupArt';
import s from './ArtBrandedMobilePopup.scss';
const ArtBrandedMobilePopup = ({ artImageSrc, artAuthor, onClose, popupProps = {}, children })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(Popup, _object_spread({
        className: s['modal'],
        onRequestClose: onClose
    }, popupProps), /*#__PURE__*/ React.createElement("div", {
        className: s['root'],
        style: {
            backgroundImage: artImageSrc && `url(${artImageSrc})`
        }
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['inner']
    }, /*#__PURE__*/ React.createElement(Logo, {
        size: "tiny",
        markColor: "white",
        textColor: "white"
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['content']
    }, children), /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['artist-credit'], artAuthor && s['loaded'])
    }, artAuthor && /*#__PURE__*/ React.createElement(React.Fragment, null, t('verification.artistCredit'), ' ', /*#__PURE__*/ React.createElement(UserLink, {
        className: s['user-link'],
        user: artAuthor
    }))))));
};
export default withPopupArt(ArtBrandedMobilePopup);

//# sourceMappingURL=ArtBrandedMobilePopup.js.map